export default __webpack_public_path__ + "static/circle-pattern-12ccb2da18fe067b3ae0fd8033eaf1a4.svg";